import { useMutation } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";
import { registerForPush } from "../../../lib/push";

/**
 * Register this install with APNs and hand the device token to the API. Never
 * prompts — call it only once permission is granted.
 *
 * Re-posting is the point, not a waste: it is how the server repoints the
 * token to whoever is signed in now and refreshes its last-seen time (tokens
 * unseen for 60 days are pruned), so it runs on every app start and resume.
 * Silent on failure — the next resume tries again, and alerts reach the inbox
 * and email regardless.
 */
export const useRegisterPushToken = () =>
  useMutation({
    mutationFn: async (): Promise<void> => {
      const token = await registerForPush();
      if (token === null) return;
      await api.post("/device-tokens", { token, platform: "ios" });
    },
    retry: false,
  });
